import React, { Fragment, useState, useEffect } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import {
  Glyphicon,
  FormControl,
  InputGroup,
  Button,
  FormGroup,
  Radio,
} from "react-bootstrap";
import moment from "moment";
import { DateRangeConfig } from "../config";

const currentYear = new Date().getFullYear();
const numberOfYearOptions = 5;
const range = (start, stop, step) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
const yearOptions = range(
  currentYear,
  currentYear - numberOfYearOptions + 1,
  -1
);

const DateFilter = ({
  startDate,
  endDate,
  onChange,
  isAdvanceDateFilter = false,
  hasSearched,
}) => {
  const [isAdvMode, setIsAdvMode] = useState(false);
  const [advModeOptionValue, setAdvModeOptionValue] = useState(
    DateRangeConfig.ADV_OPTIONS.range
  );
  const [refreshDateFilter, setRefreshDateFilter] = useState(Date.now());
  const advModeOptions = [
    {
      id: DateRangeConfig.ADV_OPTIONS.range,
      name: "Range",
    },
    {
      id: DateRangeConfig.ADV_OPTIONS.yearly,
      name: "Yearly",
    },
    {
      id: DateRangeConfig.ADV_OPTIONS.alltime,
      name: "All Time",
    },
  ];
  const [yearOptionValue, setYearOptionValue] = useState(0);

  useEffect(() => {}, []);

  useEffect(() => {
    setRefreshDateFilter(Date.now());
    if (!hasSearched) {
      setIsAdvMode(false);
      setAdvModeOptionValue(DateRangeConfig.ADV_OPTIONS.range);
      onChange({
        target: { name: DateRangeConfig.ADV_ACTIONS.dateFilterReset },
      });
    }
  }, [hasSearched]);

  useEffect(() => {
    if (advModeOptionValue === DateRangeConfig.ADV_OPTIONS.range) {
      onChange({
        target: { name: DateRangeConfig.ADV_ACTIONS.dateFilterReset },
      });
      setYearOptionValue(0);
    } else if (advModeOptionValue === DateRangeConfig.ADV_OPTIONS.alltime) {
      onChange({
        target: { name: DateRangeConfig.ADV_ACTIONS.dateFilterAlltime },
      });
      setYearOptionValue(0);
    } else if (advModeOptionValue === DateRangeConfig.ADV_OPTIONS.yearly) {
      setYearOptionValue(currentYear);
    }
  }, [advModeOptionValue]);

  useEffect(() => {
    if (advModeOptionValue === DateRangeConfig.ADV_OPTIONS.yearly) {
      onChange(
        { target: "" },
        {
          startDate: moment([yearOptionValue, 0]),
          endDate: moment([yearOptionValue, 11]).endOf("month"),
        }
      );
    }
  }, [yearOptionValue]);

  return (
    <Fragment>
      {isAdvMode && (
        <div style={{ marginBottom: 20 }}>
          <span style={{ fontWeight: "bold" }}>Advanced Date Filter: </span>
          <select
            className="form-control"
            value={advModeOptionValue}
            style={{ marginTop: 10 }}
            onChange={(e) => {
              setAdvModeOptionValue(e.target.value);
            }}
          >
            {advModeOptions.map((option, index) => (
              <option key={index} value={option.id}>
                {option.name}
              </option>
            ))}
          </select>
        </div>
      )}
      {advModeOptionValue === DateRangeConfig.ADV_OPTIONS.range && (
        <DateRangePicker
          key={refreshDateFilter}
          startDate={startDate}
          endDate={endDate}
          onApply={onChange}
          dateLimit={
            isAdvanceDateFilter && hasSearched
              ? 0
              : DateRangeConfig.MAX_DATERANGE
          }
        >
          <InputGroup>
            <FormControl
              type="text"
              value={`${startDate} - ${endDate}`}
              readOnly
            />
            <InputGroup.Addon>
              <Glyphicon glyph="calendar" />
            </InputGroup.Addon>
          </InputGroup>
        </DateRangePicker>
      )}
      {advModeOptionValue === DateRangeConfig.ADV_OPTIONS.yearly && (
        <FormGroup
          style={{ marginLeft: 10 }}
          onChange={(e) => {
            setYearOptionValue(parseInt(e.target.value));
          }}
        >
          {yearOptions.map((year) => (
            <Radio
              name="radioGroup"
              value={year}
              checked={year === yearOptionValue}
            >
              {year}
            </Radio>
          ))}
        </FormGroup>
      )}
      {isAdvanceDateFilter && hasSearched && !isAdvMode && (
        <Button
          bsStyle="link"
          style={{ float: "right", paddingRight: 0 }}
          onClick={() => setIsAdvMode(true)}
        >
          More Date Filters
        </Button>
      )}
    </Fragment>
  );
};

export default DateFilter;
